import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import { Dayjs } from "dayjs";
import { useContext, useEffect, useState } from "react";
import { TimePicker } from "@mui/x-date-pickers";
// import { DatePicker } from "@mui/x-date-pickers";



export default function SelectSyncHourOne({ disabled, ...props }) {
  return (

    <TextField
        disabled={disabled}
        id="time"
        label="Sincronismo 1"
        type="time"
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 3600, // 5 min
        }}
        sx={{ width: 150 }}
        {...props}
      />





    // <LocalizationProvider dateAdapter={AdapterDayjs}>
    //   <TimePicker
    //     disabled={disabled}
    //     label="Sincronismo 1"
    //     value={value}
    //      onChange={handleChange}
    //     renderInput={(params) => <TextField {...params} />}
    //   />
    // </LocalizationProvider>
  );
}
